// export component

export {
    PremiumDomainConnectFirstStepLightable,
    PremiumDomainConnectFirstStep,
    PremiumDomainConnectSecondStep,
    lazyMountAndShowDCSecondStep,
} from './lazyFunctions';

export { LightningProps } from 'owa-lightning-v2';
export { initializeDomainConnectRoutes } from './routing/domainConnectRoutes';
export { domainConnectFetchDomainService } from './services/domainConnectFetchDomain';
export { DomainConnectFetchSetupResponse } from './contract/DomainConnectFetchSetupResponse';
export { default as DomainDataItemResponse } from './contract/DomainDataItemResponse';
export { default as domainConnectFetchSetupInfoService } from './services/domainConnectFetchSetupInfoService';
export { default as domainConnectCreateAndValidateLegacyDomainService } from './services/domainConnectCreateAndValidateLegacyDomainService';
export { default as DomainPurchaseType } from './contract/DomainPurchaseType';
export const HMPlusBit = 2;
export { ComponentClass } from 'react';
